// openRecommendDiamondPackSelector.js
'use strict';
import { MERGE_OPERATION_DATA, SET_LIST_ITEMS } from '../ActionTypes.js';
import addvalue from '../action/addvalue.js';
import openAddvalueModal from '../action/openAddvalueModal.js';
import { SHOP_ID, ShopModalType } from '../resource/shopConstants.js';
import { payment as paymentDebug } from '../resource/debug.js';

const log = paymentDebug.extend('log:openRecommendDiamondPackSelector');

/**
 * Open specified diamond pack selector
 * @kind action
 * @param {array} {[productIds = []]} - product ids.
 * @param {array} {[categories = []]} - product categories.
 * @param {array} {[sections = []]} - shop sections.
 * @param {string} {via} - where open specified diamond pack selector.
 * @param {string} {currency} - currency.
 * @param {string} {recommendProductId} - recommend product id.
 * @return {Promise} Action promise.
 */
const openRecommendDiamondPackSelector =
  ({
    productIds = [],
    categories = [],
    sections = [],
    currency,
    via,
    recommendProductId,
  }) =>
  async dispatch => {
    log('start', {
      via,
      currency,
      recommendProductId,
      productIds: productIds.join(', '),
      categories: categories.join(', '),
      sections: sections.join(', '),
    });

    if (
      productIds.length === 0 &&
      categories.length === 0 &&
      sections.length === 0
    ) {
      log('no products, open default shop', { via });
      return dispatch(addvalue({ via }));
    }
    dispatch({
      type: MERGE_OPERATION_DATA,
      payload: {
        selectPath: ['shop'],
        data: {
          currency,
        },
      },
    });
    dispatch({
      type: MERGE_OPERATION_DATA,
      payload: {
        selectPath: ['shop', SHOP_ID.addvalue],
        data: {
          recommendProductId,
          categories,
          sections,
          // recommend flow supplies its own sections; mark as the full shop
          // so `isQuickpay` stays false without hitting the sections API.
          modalType: ShopModalType.ADDVALUE,
        },
      },
    });
    dispatch({
      type: SET_LIST_ITEMS,
      payload: {
        selectPath: ['shop', SHOP_ID.addvalue, 'products'],
        itemIds: productIds,
        totalCount: productIds.length,
      },
    });
    // stashed products/sections already provided — skip the sections API
    return dispatch(openAddvalueModal({ via }));
  };

export default openRecommendDiamondPackSelector;
